// Dollar Prices Vuex

import state from './dollarRateStates.js'
import * as getters from './dollarRateGetters.js'
import * as mutations from './dollarRateMutations.js'
import * as actions from './dollarRateActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
